import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class RSAHelper {
  publicKey: string 

  constructor() {
     
  }

  encryptWithPublicKey(valueToEncrypt: string): string {
 
    this.publicKey = `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA7MbSsZ1YeNnlwAvlpDR2dmql
    I022LlfLM3LXCNkLirikM1rNfNGPdM8QVZC1oDpkCZrCZ7Dkdo3uXQUK7P2lJE3F
    OUKdhkNHVjkjz8wk9Ehnhs3J06dlCxlyy+GfAeiuN76ODYVTmqFE0KIX/XJra3Lr
    ow7i/LLWFZJOeU3DIQIDAQAB
    -----END PUBLIC KEY-----`;
    
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }
}